import { render } from "./productoSeleccionadoCard.vue?vue&type=template&id=a420bc00&scoped=true"
import script from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"
export * from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"

import "./productoSeleccionadoCard.vue?vue&type=style&index=0&id=a420bc00&scoped=true&lang=css"
import "./productoSeleccionadoCard.vue?vue&type=style&index=1&id=a420bc00&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a420bc00"]])

export default __exports__